/* KIAURA tee purchase state (pre-order + first-party Klaviyo back in stock).
   Pairs with snippets/tee-purchase-state.liquid. The widget and its variant
   data render server side inside the product section, so AJAX colorway swaps
   always carry a fresh widget. Every listener is delegated on document and
   nothing needs re-initializing after a swap.

   These variants are CONTINUE policy, so variant.available stays true at zero
   stock. State keys off inventory instead:

     inventory > 0    Symmetry's <buy-buttons> shows, widget hidden
     inventory <= 0   <buy-buttons> hides, pre-order + notify show

   Symmetry renders <select name="id"> carrying the real variant id, so the
   selected variant is a single read rather than walking option radios. */
(function () {
  var REVISION = '2024-10-15';
  var ATC_SELECTOR = 'buy-buttons';

  function scopeFor(widget) {
    return widget.closest('.shopify-section') || document;
  }

  function readVariants(widget) {
    if (widget.__teeVariants) return widget.__teeVariants;
    var el = widget.querySelector('[data-tee-variants]');
    try { widget.__teeVariants = el ? JSON.parse(el.textContent) : []; }
    catch (e) { widget.__teeVariants = []; }
    return widget.__teeVariants;
  }

  function currentVariant(widget) {
    var scope = scopeFor(widget);
    var variants = readVariants(widget);
    if (!variants.length) return null;

    var idField = scope.querySelector('[name="id"]');
    if (idField && idField.value) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(idField.value)) return variants[i];
      }
    }

    // Fallback: match on checked option radios, in option order.
    var picked = [];
    scope.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
      if (/-option$/.test(r.name || '')) picked.push(r.value);
    });
    if (picked.length) {
      for (var v = 0; v < variants.length; v++) {
        var ok = true;
        for (var j = 0; j < picked.length; j++) {
          if (String(variants[v].options[j] || '') !== String(picked[j] || '')) { ok = false; break; }
        }
        if (ok) return variants[v];
      }
    }
    return variants[0] || null;
  }

  function isPreorder(variant) {
    if (!variant) return false;
    return Number(variant.inventory) <= 0;
  }

  function refreshWidget(widget) {
    var variant = currentVariant(widget);
    widget.__teeSelected = variant;

    var pre = isPreorder(variant);
    /* Publish state only. The one native <buy-buttons> stays put and
       tee-packs.js owns its label, so no element is ever swapped in or out and
       the layout cannot shift. */
    window.__teePreorder = pre;
    window.__teeShipDate = widget.getAttribute('data-ship-date') || '';

    var notify = widget.querySelector('[data-restock-trigger]');
    if (notify) notify.hidden = !pre;

    document.dispatchEvent(new CustomEvent('tee:statechange'));
  }

  function refreshAll() {
    document.querySelectorAll('[data-tee-purchase]').forEach(refreshWidget);
  }

  /* The widget renders inside the product section where ancestor transforms
     trap position:fixed. Portal the overlay to <body> on first open and keep a
     back-reference so submit can find its widget. */
  function overlayFor(widget) {
    if (widget.__teeOverlay && document.body.contains(widget.__teeOverlay)) return widget.__teeOverlay;
    var overlay = widget.querySelector('[data-restock-modal]');
    if (overlay) {
      document.querySelectorAll('body > [data-restock-modal]').forEach(function (o) { o.remove(); });
      document.body.appendChild(overlay);
      overlay.__teeWidget = widget;
      widget.__teeOverlay = overlay;
    }
    return overlay;
  }

  function widgetForNode(node) {
    var overlay = node.closest('[data-restock-modal]');
    if (overlay && overlay.__teeWidget) return overlay.__teeWidget;
    return node.closest('[data-tee-purchase]');
  }

  function openPanel(widget) {
    if (!widget) return;
    refreshWidget(widget);
    var variant = widget.__teeSelected;
    var overlay = overlayFor(widget);
    if (!overlay || !variant) return;

    var label = overlay.querySelector('[data-restock-variant-label]');
    if (label) {
      var names = [];
      try { names = JSON.parse(widget.getAttribute('data-option-names') || '[]'); } catch (e) {}
      var parts = [];
      for (var n = 0; n < variant.options.length; n++) {
        parts.push(names[n] ? names[n] + ': ' + variant.options[n] : variant.options[n]);
      }
      label.textContent = parts.length ? parts.join(' · ') : (variant.title || '');
    }

    var form = overlay.querySelector('[data-restock-step="form"]');
    var done = overlay.querySelector('[data-restock-step="success"]');
    if (form) form.hidden = false;
    if (done) done.hidden = true;
    var err = overlay.querySelector('[data-restock-error]');
    if (err) err.hidden = true;

    overlay.hidden = false;
    document.documentElement.classList.add('tee-restock-open');
    var email = overlay.querySelector('[data-restock-email]');
    if (email) setTimeout(function () { email.focus(); }, 50);
  }

  function closePanel(overlay) {
    overlay.hidden = true;
    document.documentElement.classList.remove('tee-restock-open');
  }

  function subscribe(widget) {
    if (!widget) return;
    var overlay = widget.__teeOverlay || widget.querySelector('[data-restock-modal]');
    if (!overlay) return;

    var variant = widget.__teeSelected;
    var emailInput = overlay.querySelector('[data-restock-email]');
    var err = overlay.querySelector('[data-restock-error]');
    var btn = overlay.querySelector('[data-restock-submit]');
    var email = ((emailInput && emailInput.value) || '').trim();
    if (!variant) return;

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (err) { err.textContent = 'Enter a valid email address.'; err.hidden = false; }
      return;
    }
    if (err) err.hidden = true;
    if (btn) { btn.disabled = true; btn.__teeLabel = btn.textContent; btn.textContent = 'Sending...'; }

    var account = widget.getAttribute('data-restock-account');

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(account), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant.id } }
          }
        }
      })
    })
      .then(function (res) {
        if (!res.ok) return res.text().then(function (t) { throw new Error(t || String(res.status)); });
        var f = overlay.querySelector('[data-restock-step="form"]');
        var d = overlay.querySelector('[data-restock-step="success"]');
        if (f) f.hidden = true;
        if (d) d.hidden = false;
      })
      .catch(function () {
        if (err) { err.textContent = 'Something went wrong. Try again.'; err.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.__teeLabel || 'Notify Me'; }
      });
  }

  /* Pre-order adds to cart through Symmetry's own hidden ATC so its loader
     button, cart drawer and analytics all behave normally. */
  document.addEventListener('click', function (e) {

    var trigger = e.target.closest('[data-restock-trigger]');
    if (trigger) { e.preventDefault(); openPanel(trigger.closest('[data-tee-purchase]')); return; }

    var closeEl = e.target.closest('[data-restock-close]');
    if (closeEl) {
      var overlay = closeEl.closest('[data-restock-modal]');
      if (overlay) closePanel(overlay);
      return;
    }

    var submitBtn = e.target.closest('[data-restock-submit]');
    if (submitBtn) { e.preventDefault(); subscribe(widgetForNode(submitBtn)); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('[data-restock-modal]:not([hidden])');
      if (open) closePanel(open);
      return;
    }
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-restock-email]')) {
      e.preventDefault();
      subscribe(widgetForNode(e.target));
    }
  });

  /* Size changes: Symmetry updates [name="id"], so refresh once it has. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[name="id"]') || t.matches('input[type="radio"]')) setTimeout(refreshAll, 0);
  }, true);

  /* Pack size changed: re-evaluate who owns the ATC slot. */
  document.addEventListener('tee:packchange', function () { setTimeout(refreshAll, 0); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  /* AJAX colorway swaps replace the product section wholesale; sync when a
     new widget lands. */
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('[data-tee-purchase]')) ||
            (n.querySelector && n.querySelector('[data-tee-purchase]'))) {
          setTimeout(refreshAll, 0);
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
